import __var_0__ from '@stdlib/array/float64';
import __var_1__ from '@stdlib/array/float32';
import __var_2__ from '@stdlib/array/uint32';
import __var_3__ from '@stdlib/array/int32';
import __var_4__ from '@stdlib/array/uint16';
import __var_5__ from '@stdlib/array/int16';
import __var_6__ from '@stdlib/array/uint8';
import __var_7__ from '@stdlib/array/uint8c';
import __var_8__ from '@stdlib/array/int8';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var Float64Array = __var_0__;
var Float32Array = __var_1__;
var Uint32Array = __var_2__;
var Int32Array = __var_3__;
var Uint16Array = __var_4__;
var Int16Array = __var_5__;
var Uint8Array = __var_6__;
var Uint8ClampedArray = __var_7__;
var Int8Array = __var_8__;


// MAIN //

// Note: order should match `dtypes` order
var CTORS = [
	Float64Array,
	Float32Array,
	Int32Array,
	Uint32Array,
	Int16Array,
	Uint16Array,
	Int8Array,
	Uint8Array,
	Uint8ClampedArray
];


// EXPORTS //
export default CTORS;
